import React from 'react';

const ClockIcon = () => (
    <svg width="14" height="14" viewBox="0 0 16 16" fill="none" stroke="currentColor"
         strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <circle cx="8" cy="8" r="6.25"/>
        <path d="M8 4.75V8l2.25 1.5"/>
    </svg>
);

export default ClockIcon;